import {Component, Input, OnInit} from "@angular/core";
import {ProductCollectionsEnum} from "../../../../../../shared/enums/product-collections.enum";
import {SearchScopeEnum} from "../../../../../../shared/enums/search-scope.enum";
import {LinkModel} from "../../../../../../shared/models/link.model";
import {ProductScopeConfigModel} from "../../../../../models/search-config/scopes/product-scope-config.model";
import {ContentSearchConfigService} from "../../../../../services/content-search-config.service";

@Component({
    selector: "pcg-ng-advanced-search-link",
    template: require('./advanced-search-link.component.html'),
    styles: []
})
export class AdvancedSearchLinkComponent implements OnInit {
    private availableFor: Array<ProductCollectionsEnum> = new Array<ProductCollectionsEnum>();

    @Input()
    public currentCollection: ProductCollectionsEnum;

    public advancedSearchLink: LinkModel;

    public constructor(
        private searchConfigService: ContentSearchConfigService
    ) {
    }

    public ngOnInit(): void {
        const productConfig = this.searchConfigService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        this.advancedSearchLink = productConfig.advancedSearch.link;
        this.availableFor = productConfig.advancedSearch.availableFor;
    }

    public isAvailable(): boolean {
        return this.availableFor.indexOf(this.currentCollection) > -1;
    }
}
